import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { TimeSelectStyled } from "./styled";
import { useTranslation } from "react-i18next";

const TimeSelect = ({ theme_standard, errors, ...props }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });
  
  const { t } = useTranslation(["common"]);
  return (
    <TimeSelectStyled className={customClass}>
      <input className="time_select" type="time" {...props} />
      {errors && <div className="errors">{t(errors, { ns: "common" })}</div>}
    </TimeSelectStyled>
  );
};

TimeSelect.propTypes = {};

export default TimeSelect;
